const WHATSAPP_PHONE = '614183150';
const WHATSAPP_MESSAGE = 'Hola, quiero mas informacion sobre FactuPYME.';

function WhatsAppFloatButton() {
  const href = `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      title="Contactar por WhatsApp"
      className="fixed bottom-6 right-6 z-[70] inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-black/30 transition-transform duration-200 hover:scale-105 hover:bg-[#20c05c] focus:outline-none focus:ring-2 focus:ring-white/80 focus:ring-offset-2 focus:ring-offset-[#080f14]"
    >
      <svg viewBox="0 0 32 32" className="h-7 w-7" aria-hidden="true">
        <path
          fill="currentColor"
          d="M16 3.2C8.93 3.2 3.2 8.93 3.2 16c0 2.24.59 4.44 1.7 6.37L3.2 28.8l6.58-1.65A12.7 12.7 0 0 0 16 28.8c7.07 0 12.8-5.73 12.8-12.8S23.07 3.2 16 3.2zm0 23.33c-1.95 0-3.86-.52-5.52-1.49l-.4-.24-3.9.98 1.04-3.8-.26-.4A10.5 10.5 0 1 1 16 26.53zm5.78-7.88c-.32-.16-1.9-.94-2.19-1.05-.3-.11-.51-.16-.73.16-.22.32-.84 1.05-1.03 1.27-.19.22-.38.24-.7.08-.32-.16-1.35-.5-2.57-1.6-.95-.85-1.6-1.9-1.79-2.22-.19-.32-.02-.49.14-.64.14-.14.32-.38.48-.57.16-.19.22-.32.32-.54.11-.22.05-.41-.03-.57-.08-.16-.73-1.76-1-2.41-.26-.62-.52-.54-.73-.55h-.62c-.22 0-.57.08-.86.41-.3.32-1.14 1.11-1.14 2.7s1.16 3.12 1.32 3.34c.16.22 2.28 3.48 5.52 4.87.77.33 1.37.53 1.84.67.78.25 1.48.22 2.03.13.62-.09 1.9-.78 2.17-1.54.27-.76.27-1.41.19-1.54-.08-.14-.3-.22-.62-.38z"
        />
      </svg>
    </a>
  );
}

export default WhatsAppFloatButton;
